export default function Spinner (){
    return(
        <div className="loadingSpace">
          <span className="loader"></span>
          <p>Loading...</p>
        </div>
        )
}